export default __webpack_public_path__ + "static/media/all-other-assignment-img.272fd7fe.svg";